import { Box } from "@mui/material";
import CustomButton from "Components/shared/Button";
import DropdownMenu from "Components/shared/DropdownMenu";
import { useRTL } from "hooks/isRTL";
import SearchBar from "Components/shared/SearchBar";
import ExportButton from "Components/shared/ExportButton";
import { DriverTypeEnum } from "enums/shared";

const DriverSearch = ({
  filters,
  setFilters,
  setDescendingNameSort,
  setDescendingAgeSort,
  setDescendingCreationDateSort,
  setDescendingModificationDateSort,
  setPage,
  searchValue,
  onSearchChange,
}) => {
  const { t } = useRTL();

  const handleClearFilters = () => {
    const clearedFilters = {
      fullName: "",
      phoneNumber: "",
      city: "",
      status: [],
      driverType: null,
    };
    setDescendingNameSort(null);
    setDescendingAgeSort(null);
    setDescendingCreationDateSort(null);
    setDescendingModificationDateSort(null);
    setPage(0);

    setFilters(clearedFilters);
    onSearchChange("");
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "16px",
        borderRadius: "8px",
        marginBottom: "5px",
        backgroundColor: "white",
        padding: "16px",
      }}
    >
      <Box sx={{ flex: 1, maxWidth: "350px" }}>
        <SearchBar
          value={searchValue}
          onSearch={onSearchChange}
          placeholder={t("searchDriverByName")}
        />
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <DropdownMenu
          placeholder="Driver Type"
          options={[
            { value: DriverTypeEnum.regular, label: t("regular") },
            { value: DriverTypeEnum.expedited, label: t("expedited") },
          ]}
          onChange={(value) => {
            setPage(0);
            setFilters((prev) => ({
              ...prev,
              driverType: value === "" ? null : value,
            }));
          }}
          value={filters?.driverType ?? ""}
        />

        <CustomButton onClick={handleClearFilters}>
          {t("clearFilters")}
        </CustomButton>
        <ExportButton reportType="DriverManagement" />
      </Box>
    </Box>
  );
};

export default DriverSearch;
